import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Flex,
  Row,
  Space,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { EditOutlined, ReloadOutlined } from "@ant-design/icons";
import {
  callGetDashboardLottos
} from "../../../../services/lottoService";
import { showNotificationTopEnd, maskDate } from "../../../../util/utils";
import { DASHBOARD_LOTTOS } from "../../../../constants/AppConstants";
import LottoModalSteps from "../LottoModalSteps/LottoModalSteps";

import "./LottoList.css";
import LottoModalStatus from "../LottoModalStatus/LottoModalStatus";

const { Title } = Typography;

export default function LottoList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalCreateVisible, setModalCreateVisible] = useState(false);
  const [modalChangeStatusVisible, setModalChangeStatusVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const getLottos = async (page, size) => {
    setLoading(true);

    const response = await callGetDashboardLottos(page, size);
    if (response?.status === 200) {
      setData(response.data.content);
      setPagination({
        current: page + 1,
        pageSize: size,
        total: response.data?.page?.totalElements,
      });
    } else {
      showNotificationTopEnd("error", "Error, por favor recarga la pagina");
    }
    setLoading(false);
  };

  useEffect(() => {
    getLottos(pagination.current - 1, pagination.pageSize);
    // eslint-disable-next-line
  }, [reload]);

  const handleTableChange = (pagination) => {
    getLottos(pagination.current - 1, pagination.pageSize);
  };

  const handleEdit = (record) => {
    if (record.status === DASHBOARD_LOTTOS.STATUS.CLOSED || record.status === DASHBOARD_LOTTOS.STATUS.COMPLETED) {
      showNotificationTopEnd("error", "No se puede editar un sorteo cerrado o completado");
      return;
    }
    setSelectedRecord(record);
    setModalCreateVisible(true);
  };

  const handleEditStatus = (record) => {
    setSelectedRecord(record);
    setModalChangeStatusVisible(true);
  };

  const columns = [
    {
      title: DASHBOARD_LOTTOS.COLUMNS.ID,
      dataIndex: "lottoId",
      key: "lottoId",
      width: 80,
    },
    {
      title: DASHBOARD_LOTTOS.COLUMNS.LOTTO_NUMBER,
      dataIndex: "lottoNumber",
      key: "lottoNumber",
      width: 80,
    },
    {
      title: DASHBOARD_LOTTOS.COLUMNS.TITLE,
      dataIndex: "title",
      key: "title",
    },
    {
      title: DASHBOARD_LOTTOS.COLUMNS.TICKET_AMOUNT,
      dataIndex: "ticketAmount",
      key: "ticketAmount",
      width: 80,
    },
    {
      title: DASHBOARD_LOTTOS.COLUMNS.TICKET_PRICE,
      dataIndex: "ticketPrice",
      key: "ticketPrice",
      width: 80,
    },
    {
      title: DASHBOARD_LOTTOS.COLUMNS.OPPORTUNITIES,
      dataIndex: "opportunities",
      key: "opportunities",
      width: 80,
    },
    {
      title: DASHBOARD_LOTTOS.COLUMNS.LOTTO_DATE,
      dataIndex: "lottoDate",
      key: "lottoDate",
      render: (value) => maskDate(value),
    },
    {
      title: DASHBOARD_LOTTOS.COLUMNS.PUBLISHED_DATE,
      dataIndex: "publishedDate",
      key: "publishedDate",
      render: (value) => maskDate(value),
    },
    {
      title: DASHBOARD_LOTTOS.COLUMNS.STATUS,
      dataIndex: "status",
      key: "status",
      render: (value) => {
        switch (value) {
          case DASHBOARD_LOTTOS.STATUS.ACTIVE:
            return <Tag color="cyan">{DASHBOARD_LOTTOS.STATUS.ACTIVE}</Tag>;
          case DASHBOARD_LOTTOS.STATUS.CREATED:
            return <Tag color="blue">{DASHBOARD_LOTTOS.STATUS.CREATED}</Tag>;
          case DASHBOARD_LOTTOS.STATUS.COMPLETED:
            return <Tag color="green">{DASHBOARD_LOTTOS.STATUS.COMPLETED}</Tag>;
          case DASHBOARD_LOTTOS.STATUS.CLOSED:
            return <Tag color="lime">{DASHBOARD_LOTTOS.STATUS.CLOSED}</Tag>;
          case DASHBOARD_LOTTOS.STATUS.ELIMINATED:
            return <Tag color="red">{DASHBOARD_LOTTOS.STATUS.ELIMINATED}</Tag>;
          default:
            return <Tag color="gold">{DASHBOARD_LOTTOS.STATUS.PENDING}</Tag>;
        }
      },
    },
    {
      title: DASHBOARD_LOTTOS.COLUMNS.ACTIONS,
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title={DASHBOARD_LOTTOS.ACTIONS.TOOLTIPS.EDIT}>
            <Button
              shape="circle"
              icon={<EditOutlined />}
              type="primary"
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Tooltip title={DASHBOARD_LOTTOS.ACTIONS.TOOLTIPS.EDIT_STATUS}>
            <Button
              shape="circle"
              icon={<ReloadOutlined />}
              color="cyan" variant="solid"
              onClick={() => handleEditStatus(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <Flex vertical>
      <Row
        gutter={[16, 16]}
        justify="space-between"
        align="middle"
        style={{ marginBottom: 24 }}
      >
        <Col span="auto">
          <Title level={3}>{DASHBOARD_LOTTOS.TITLE}</Title>
        </Col>
        <Col span="auto">
          <Button
            color="green"
            variant="solid"
            onClick={() => setModalCreateVisible(true)}
          >
            {DASHBOARD_LOTTOS.ACTIONS.CREATE_TITLE}
          </Button>
          <LottoModalSteps
            visible={modalCreateVisible}
            onClose={() => {
              setModalCreateVisible(false);
              setSelectedRecord(null);
              setReload(!reload);
            }}
            selectedRecord={selectedRecord}
          // onSubmit={(values) =>
          //   selectedRecord
          //     ? callUpdateDashboardLotto(values)
          //     : callCreateDashboardLotto(values)
          // }
          />
          <LottoModalStatus
            visible={modalChangeStatusVisible}
            onClose={() => {
              setModalChangeStatusVisible(false);
              setSelectedRecord(null);
              setReload(!reload);
            }}
            selectedRecord={selectedRecord}
          />
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="lottoId"
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </Flex>
  );
}
